export enum ElementThemes {
    DEFAULT = 'DEFAULT',
    MATERIAL = 'MATERIAL',
    CLASSIC = 'CLASSIC',
    STARLING = 'STARLING',
    MODERN = 'MODERN'
}
